import { gql } from '@apollo/client';
import { CustomRoleResponse } from './getAllCustomRolesNPermissions.queries';

export type GetCustomRoleInput = {
  id: string;
};

export type PermissionToCategory = {
  permission: string;
  category: string;
};

export interface CustomRole extends Omit<CustomRoleResponse, 'permissions'> {
  permissionsToCategories: PermissionToCategory[];
}

export type GetCustomRoleResponse = {
  customRole: CustomRole;
};

export const GET_CUSTOM_ROLE_BY_ID = gql`
  query customRole($input: CustomRoleIDInput!) {
    customRole(input: $input) {
      id
      name
      description
      permissionsToCategories {
        permission
        category
      }
      organisation {
        code
        name
      }
    }
  }
`;
